<template>
  <div class="vertical-nav-header d-flex align-center justify-space-between ps-5 pe-4 pt-1 pb-1" >
    <div
      to="/"
      style="width: 100%;"
      class="align-center text-decoration-none"
    >
      <!-- <v-img
        :src="appLogo"
        height="42px"
        alt="logo"
        contain
        eager
        class="app-logo"
      ></v-img> -->
				<div class="logo-box">
					<img v-if="$store.state.app.companyLogoBase64" :src="'data:image/png;base64,'+$store.state.app.companyLogoBase64" alt="">
					<img v-else src="@/assets/img/logo.png" alt="">
				</div>
      <!-- <v-slide-x-transition>
        <h2
          v-show="!(menuIsVerticalNavMini && !isMouseHovered)"
          class="app-title text--primary"
        >
          {{ appName }}
        </h2>
      </v-slide-x-transition> -->
    </div>

    <!-- <v-slide-x-transition>
      <div
        v-show="!(menuIsVerticalNavMini && !isMouseHovered)"
        v-if="$vuetify.breakpoint.lgAndUp"
        class="d-flex align-center ms-1 mt-12 mr-3 icon_coll"
        @click.stop="menuIsVerticalNavMini = !menuIsVerticalNavMini"
      >
        <v-icon
          v-show="!menuIsVerticalNavMini"
          size="20"
          class="cursor-pointer"
        >
          {{ icons.mdiArrowExpandHorizontal }}
        </v-icon>
        <v-icon
          v-show="menuIsVerticalNavMini"
          size="20"
          class="cursor-pointer"
        >
          {{ icons.mdiArrowExpandHorizontal }}
        </v-icon>
      </div>
      <v-icon
        v-else
        size="20"
        class="d-inline-block"
        @click.stop="$emit('close-nav-menu')"
      >
        {{ icons.mdiArrowCollapseHorizontal }}
      </v-icon>
    </v-slide-x-transition> -->
  </div>
</template>

<script>
import { mdiRadioboxBlank, mdiRecordCircleOutline, mdiClose, mdiArrowExpandHorizontal, mdiArrowCollapseHorizontal} from '@mdi/js'
import {userPhoto} from "@/api/index";
import useAppConfig from '@core/@app-config/useAppConfig'
import themeConfig from '@themeConfig'
import { inject } from '@vue/composition-api'
import { getCookie } from '@/utils/cookie';
import store from '@/store'
export default {
  setup() {
    const { menuIsVerticalNavMini } = useAppConfig()
    const isMouseHovered = inject('isMouseHovered')



    return {

      menuIsVerticalNavMini,
      isMouseHovered,
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,

      // Icons
      icons: {
        mdiClose,
        mdiRadioboxBlank,
        mdiRecordCircleOutline,
        mdiArrowExpandHorizontal,
        mdiArrowCollapseHorizontal,
      },
      getCookie
    }
  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped>
.app-title {
  font-size: 1.25rem;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.3px;
}

// ? Adjust this `translateX` value to keep logo in center when vertical nav menu is collapsed (Value depends on your logo)
.app-logo {
  transition: all 0.18s ease-in-out;
  .v-navigation-drawer--mini-variant & {
    transform: translateX(-4px);
  }
}
.logo-box {
  margin: 10px 0;
  text-align: center;
  img {
    max-width: 166px;
    height: 43px;
  }
}
</style>
